<script>
    import { onMount } from "svelte"
    import Modal from '../components/Modal.svelte'
    import ModalOnBoarding from "../components/ModalOnBoarding.svelte"
    import ToastComponent from "../components/ToastComponent.svelte"

    import UserService from '../services/user'
    import AuthenticationService from '../services/authentication'
    import { notifications } from "../services/notification";

    import {longpress} from '../services/long'

    let loading = true
    let userSubscription
    let applicationsList = []
    let user = {}
    let message = {}

    let modalComponent
    let modalOnBoarding

    onMount(async () => {

        userSubscription = AuthenticationService.userSubscription.subscribe(userElement => {
            user = userElement
            console.log("USER", user)
        })

        let result = await UserService.getAppsFromOneUser(user.id)
        console.log("result", result)
        if(result.success) applicationsList = result.data
        if(!result.success) notifications.danger(result.data.message)

        console.log("USER SUER", user)
        if(user.first_connection) modalOnBoarding.start()

        loading = false

    })

    const handleOnBoarding = async (event) => {
        console.log(event.detail)

        if(event.detail.action === "finished") {
            let result = await UserService.updateOneOnBoardingUser(user.id, { first_connection : false })
            console.log("result", result)

            if(result.success) AuthenticationService.setFirstConnection(false)
            if(!result.success) notifications.danger(result.data.message)
        }
    }

    const openModal = (data) => {
        if(!data) return
        modalComponent.start(data)
    }

    const directOpen = (url) => {
        window.open(url, '_blank').focus()
    }

    const getGroupName = (name) => {
        if(!name) return ""
        let splittedName = name.split('-')
        return splittedName[1].trim()
    }


</script>

<div class="container">	
    <!-- <pre>{JSON.stringify(applicationsList, undefined, 1)}</pre> -->
    <div class="row pt-5">
        <div class="col-md-6">
            <h1 class="text-white">Bienvenue !👋</h1>
        </div>
    </div>

    {#if message.title}
    <div class="row pt-5">
        <div class="col-md-6">
            <h2 class="text-white">{message.title}</h2>
            {#if message.subtitle}
            <div class="alert alert-primary mt-4" role="alert">
                {message.subtitle}
                <p class="alert-author">{message.author}</p>
            </div>
            {/if}
        </div>
    </div>
    {/if} 

    {#if applicationsList.length == 0 && !loading}
    <div class="row pt-5">
        <div class="col-md-6">
            <h3 class="text-white">Ton profil est en cours de création. </h3>
            <h3 class="text-white">Ton profil est en cours de création. Merci de revenir dans quelques minutes.</h3>
        </div>
    </div>
    {/if}

    {#each applicationsList as groupL}
    <div class="row pt-4">
        <div class="col-md-6">
            <h3 class="text-white">{getGroupName(groupL.group)}</h3>
        </div>
    </div>
        {#each groupL.apps as application}
            {#if application.is_active}
            <div class="row ">
                <div class="col-md-4">
                    <button type="button" class="btn btn-light button-style" use:longpress on:click={openModal(application)} on:long={directOpen(application.main_url)}>
                        <img class="icon" src="icons/{application.icon}" alt=""/>
                        {application.name}
                    </button>
                </div>
            </div>
            {/if}
        {/each}
    {/each}
</div>

<Modal bind:this="{modalComponent}"></Modal>
<ModalOnBoarding bind:this="{modalOnBoarding}" on:message={handleOnBoarding}></ModalOnBoarding>
<ToastComponent></ToastComponent>

<style>

.icon {
    width : 35px;
}

.alert-author {
    text-align: right;
    margin: 10px 0px 0px 0px;
    font-size: 13px;
}

.button-style {
    background-color: #f8f9fad9;
    width: 100%;
    margin-bottom: 15px;
    padding: 10px;
    text-align: left;
}

</style>
